import styled from '@emotion/styled'
import Button from '../../../../components/common/Button'
import Text from '../../../../components/common/Text'
import PriceFormatter from '../../../../components/PriceFormatter'
import { SHOP_PRIMARY, WHITE } from '../../../../constant/colors'
import { mobile, useScreen } from '../../../../utils/responsive-helper'

const Section = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${WHITE};
  padding: 28px;

  ${mobile} {
    width: 100%;
    position: fixed;
    bottom: 0;
    margin-left: -16px;
    padding: 14px 16px;
  }
`

const ContentStyled = styled.div`
  display: flex;
  margin-bottom: 8px;
`

const AddCartButton = styled(Button)`
  display: flex;
  width: 49%;
  border-radius: 100px;
`

type AddCartFooterProps = {
  content?: string
  icon?: JSX.Element
  textButton?: string
  value: number
  onClick?: (e: any) => void
}

const AddCartFooter = (props: AddCartFooterProps) => {
  const { isMobile } = useScreen()
  const { content, icon, textButton, value, onClick } = props
  return (
    <Section className="add-cart-footer">
      <div>
        <ContentStyled>
          {content && (
            <Text size={isMobile ? 16 : 20} style={{ lineHeight: '16px' }}>
              {content}
            </Text>
          )}
          {icon && (
            <Text size={14} style={{ lineHeight: '16px', paddingLeft: '4px' }}>
              {icon}
            </Text>
          )}
        </ContentStyled>
        <PriceFormatter fontSize={isMobile ? 28 : 36} priceType="display" value={value} />
      </div>
      {textButton && (
        <AddCartButton background={SHOP_PRIMARY} onClick={onClick}>
          {textButton}
        </AddCartButton>
      )}
    </Section>
  )
}

export default AddCartFooter
